var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_setup.buttonClasses,attrs:{"id":_vm.id,"data-cy":_vm.dataCy,"type":_vm.type,"disabled":_vm.disabled},on:{"click":_setup.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }